import useTranslation from '@/utils/hooks/translation/useTranslation';

// Types
import type { SocialProfileNetworkType } from '@/types/socialProfileType';

// Components
import { NetworkIcon } from '@/components/base/NetworkIcon';

type SupportedNetworkTypesProps = {
    supportedNetworkTypes: SocialProfileNetworkType[];
};

export function SupportedNetworkTypes({ supportedNetworkTypes }: SupportedNetworkTypesProps) {
    const { t } = useTranslation('layout_platform');
    return (
        <div className="flex flex-col gap-5 text-sm text-icoGray-500 dark:text-icoDarkMode-wolf">
            <div>{t('empty_states.supported_platforms')}</div>
            <ul className="flex flex-wrap gap-5">
                {supportedNetworkTypes.map((network) => (
                    <li key={network} className="flex items-center gap-5">
                        <NetworkIcon network={network} className="h-6 w-6 text-2xl" />
                    </li>
                ))}
            </ul>
        </div>
    );
}
